import {DatePicker, Drawer, message, Table} from 'antd';
import React, { Component } from 'react';
import Chart from "react-apexcharts";
import { connect } from 'react-redux';
import moment from "moment-timezone";
import {map, orderBy} from 'lodash';

import DataTable from "./Datatable";
import EditFranchise from '../../List/Component/EditFranchise';
import {getUserList} from '../../../../Action';
import { getFieldOffice } from '../../../../Action/FranchiseManagement/index';
import Loader from "../../../Common/Component/Loader";
import {errorHandle} from "../../../Common/errorHandle";
import { formatToCurrency } from '../../../../Tools/formatToCurrency';

// pie colors
const pie_colors = ['#407977', '#b3f3d9', '#F99D20', '#CDE059', '#3ba93f', '#abd3d2'];
const pie_colors_class = ['green-1', 'light-green', 'orange-1', 'lime', 'dark-green', 'ripple-green'];

class Overview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      is_edit_franchise: false,
      data: {},
      franchise_detail: {},
      collectionDetail: {},
      productMonth: moment(),
      addonCollectionDetail: {},
      addon_series: [],
      addon_options: {
        chart: {
          type: 'donut'
        },
        dataLabels: {
          enabled: false,
        },
        legend: {show: false},
        tooltip: {
          enabled: true,
          custom: ({series, seriesIndex}) => {
            //{series, seriesIndex, dataPointIndex, w}
            return '<div style="background-color: #FFFFFF; padding: 10px; color: #000000">' +
              '<span>' + series[seriesIndex] + '</span>' +
              '</div>'
          }
        },
        plotOptions: {
          pie: {
            expandOnClick: true,
            donut: {
              labels: {show: false},
            },
          }
        }
      },

      fullCardMonth: moment(),
      customerMatrix: {},
      revenueFilterIdx: 0,
      customerMatrixV1: {},
      customerMonth: moment(),

      line_chart_options: {
        chart: {
          toolbar: {
            show: false
          },
          foreColor: "#ccc",
        },
        colors: ["#F99D20"],
        stroke: {
          colors: ['#F99D20'],
          curve: 'smooth',
          width: 1,
        },
        grid: {
          show: false,
          padding: {
            left: 0,
            right: 0,
          }
        },
        xaxis: {
          labels: {
            show: false,
          },
        },
        yaxis: {
          show: false,
          padding: {
            left: 0,
            right: 0
          }
        },
        markers: {
          show: false
          // size: [4, 7],
          // colors: ['#C1D82F'],
        }
      },
      customerFilterIdx: 0,
      
      top_chart_options: {
        stroke: {
          colors: ['#C1D82F'],
          curve: 'smooth',
          width: 1,
        }
      },
      is_crud_allow: true
    }
    this.emptyProductChart = null
  }

  componentDidMount() {
    const user = JSON.parse(localStorage.getItem("authUser"))
    if (user.user?.role.includes('business_dev_franchiese') || user.user?.role.includes('accounting_franchiese') || user.user?.role.includes('service_rep') || user.user?.role.includes('operations_mgr')) {
      this.setState({
        is_crud_allow: false,
      })
    }

    if (!this.props.history.location.state) {
      this.props.history.push(`/franchise`);
    } else {
      const data = this.props.history.location.state.query.data;
      this.setState({ data: data, loader: true }, () => {
        const {data, productMonth, fullCardMonth, customerMonth} = this.state;
        this.props.editFieldOffice(data?.uuid)
        this.props.getCollectionDetail(`?field_office__uuid=${data?.uuid}`) // get collection detail
        this.props.getAddOnCollectionDetail(`?field_office__uuid=${data?.uuid}&timestamp__gte=${moment(productMonth).startOf('month').format('YYYY-MM-DDTHH:mm:ss')}&timestamp__lte=${moment(productMonth).endOf('month').format('YYYY-MM-DDTHH:mm:ss')}`) // get add on collection detail
        // this.props.getAddOnCollectionDetail(`?field_office__uuid=8b2e407c-240f-4f4b-a758-d117f84889bc&timestamp__gte=2021-02-01T00%3A00%3A00&timestamp__lte=2021-02-28T23%3A59%3A59`)
        let date = moment(fullCardMonth).format('DD') >= 21 ? moment(fullCardMonth).endOf('month').format('YYYY-MM-DD') : moment(fullCardMonth).format('YYYY-MM-DD')
        this.props.getDashboardStat(`?date=${date}&franchises_uuid=${data?.uuid}`)  // get dashboard stat
        this.props.getCustomerMatrix(`?field_office__uuid=${data?.uuid}&timestamp__lte=${moment().format('YYYY-MM-DD')}T23:59:59`) // get customer matrix
        this.props.getCustomerMatrix_v1(`?field_office__uuid=${data?.uuid}&timestamp__lte=${moment(customerMonth).format('YYYY-MM-DD')}T23:59:59`) // get customer matrix v1 for recurring customer signup
      });
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // message.destroy()
    ///////////// error handle ////////////////////
    if (Object.keys(nextProps?.FranchiseOverview?.errors).length > 0 && nextProps?.FranchiseOverview?.errors !== this.props?.FranchiseOverview?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.FranchiseOverview?.errors)
    }

    if (Object.keys(nextProps?.EditFieldOffice?.errors).length > 0 && nextProps?.EditFieldOffice?.errors !== this.props?.EditFieldOffice?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.EditFieldOffice?.errors)
    }
    ///////////////////////////////////////////////

    // get selected franchise detail
    if (Object.keys(nextProps?.EditFieldOffice?.data).length > 0 && nextProps?.EditFieldOffice?.data !== this.props?.EditFieldOffice?.data) {
      this.setState({franchise_detail: nextProps?.EditFieldOffice?.data, loader: false})
    }

    //Update Franchise
    if (Object.keys(nextProps?.UpdateFranchise?.data).length > 0 && nextProps?.UpdateFranchise?.data !== this.props?.UpdateFranchise?.data) {
      this.setState({franchise_detail: nextProps?.UpdateFranchise?.data, loader: false})
    }

    // get collection detail
    if (Object.keys(nextProps?.FranchiseOverview?.collectionDetail).length > 0 && nextProps?.FranchiseOverview?.collectionDetail !== this.props?.FranchiseOverview?.collectionDetail) {
      this.setState({collectionDetail: nextProps?.FranchiseOverview?.collectionDetail, loader: false})
    }

    // get add on collection detail
    if (Object.keys(nextProps?.FranchiseOverview?.addonCollectionDetail).length > 0 && nextProps?.FranchiseOverview?.addonCollectionDetail !== this.props?.FranchiseOverview?.addonCollectionDetail) {
      let addon_series = [], labels = [], addonCollectionDetail = nextProps?.FranchiseOverview?.addonCollectionDetail;
      map(addonCollectionDetail?.results, x => {
        addon_series.push(x?.revenue ? x?.revenue : 0);
        labels.push('test')
      })
      this.setState({addonCollectionDetail, addon_series, loader: false})
    }

    // get dashboard stat
    if (Object.keys(nextProps?.FranchiseOverview?.dashboardStat).length > 0 && nextProps?.FranchiseOverview?.dashboardStat !== this.props?.FranchiseOverview?.dashboardStat) {
      this.setState({dashboardStat: nextProps?.FranchiseOverview?.dashboardStat?.data, loader: false})
    }

    // get customer matrix
    if (Object.keys(nextProps?.FranchiseOverview?.customerMatrix).length > 0 && nextProps?.FranchiseOverview?.customerMatrix !== this.props?.FranchiseOverview?.customerMatrix) {
      this.setState({customerMatrix: nextProps?.FranchiseOverview?.customerMatrix, loader: false})
    }

    // get customer matrix v1
    if (Object.keys(nextProps?.FranchiseOverview?.customerMatrixV1).length > 0 && nextProps?.FranchiseOverview?.customerMatrixV1 !== this.props?.FranchiseOverview?.customerMatrixV1) {
      this.setState({customerMatrixV1: nextProps?.FranchiseOverview?.customerMatrixV1, loader: false})
    }
  }

  // calculate growth percentag
  calculateGrowthPercentage = (last_val, curr_val) => {
    let divider = last_val
    if (divider === 0) divider = 1
    return parseFloat(((curr_val - last_val) * 100) / divider).toFixed(2)
  }

  // number k and m format
  numFormatter = (num) => {
    if (num > 999 && num < 1000000) {
      return (num/1000).toFixed(1) + 'K'; // convert to K for number from > 1000 < 1 million
    } else if (num > 1000000) {
      return (num/1000000).toFixed(1) + 'M'; // convert to M for number from > 1 million
    } else if (num < 900) {
      return num; // if value < 1000, nothing to do
    }
  }

  // amount formatter
  numberWithCommas = (x) => {
    return x?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  // format phone number
  formatPhoneNumber = (phone) => {
    phone = phone?.replace(/\D/g, '');
    return phone?.substr(0, 3) + '-' + phone?.substr(3, 3) + '-' + phone?.substr(6);
  }

  //Close drawer
  closeEditDrawer = (type) => {
    this.setState({
      is_edit_franchise: type
    })
  }

  openEditDrawer = () => {
    this.props.editFieldOffice(this.state.data.uuid);
    this.setState({ is_edit_franchise: true });
  }

  // on change product month
  onChangeProductMonth = (e) => {
    this.setState({productMonth: e ? e : moment(), loader: true}, () => {
      const {data, productMonth} = this.state;
      this.props.getAddOnCollectionDetail(`?field_office__uuid=${data?.uuid}&timestamp__gte=${moment(productMonth).startOf('month').format('YYYY-MM-DDTHH:mm:ss')}&timestamp__lte=${moment(productMonth).endOf('month').format('YYYY-MM-DDTHH:mm:ss')}`)
    })
  }

  // on change product month
  onChangeFullCardMonth = (e) => {
    this.setState({fullCardMonth: e ? e : moment(), loader: true}, () => {
      const {data, fullCardMonth} = this.state;
      let date = moment(fullCardMonth).format('DD') >= 21 ? moment(fullCardMonth).endOf('month').format('YYYY-MM-DD') : moment(fullCardMonth).format('YYYY-MM-DD')
      this.props.getDashboardStat(`?date=${date}&franchises_uuid=${data?.uuid}`)
    })
  }

  // on change product month
  onChangeCustomerMonth = (e) => {
    this.setState({customerMonth: e ? e : moment(), loader: true}, () => {
      const {data, customerMonth} = this.state;
      this.props.getCustomerMatrix_v1(`?field_office__uuid=${data?.uuid}&timestamp__lte=${moment(customerMonth).format('YYYY-MM-DD')}T23:59:59`) // get customer matrix
    })
  }

  // render franchise info
  renderFranchiseInfo = () => {
    const {franchise_detail, is_crud_allow} = this.state;
    return (
      <div className="card">
        <div className="card-title flex ai-center">
          <h5>Franchise Information</h5>
          <span className={`btn ${is_crud_allow ? 'btn-warning' : 'disabled'} btn-small`} onClick={is_crud_allow ? this.openEditDrawer : null}>Update</span>
        </div>
        <div className="card-body">
          <ul className="details_list">
            <li>
              <label><b>Owner:</b></label>
              <span><b>{franchise_detail?.owner?.first_name ? `${franchise_detail?.owner?.first_name || ''} ${franchise_detail?.owner?.last_name || ''}` : ''}</b></span>
            </li>
            <li>
              <label>Year Started:	</label>
              <span>{franchise_detail?.year_started ? franchise_detail?.year_started : ''}</span>
            </li>
            <li>
              <label>Users:</label>
              <span>{franchise_detail?.users}</span>
            </li>
            <li>
              <label>Customers:	</label>
              <span>{franchise_detail?.customers ? franchise_detail?.customers : '0'}</span>
            </li>
          </ul>
          <h6>Franchise Contact Details</h6>
          <b className="d-block">Address</b>
          <p className="mb-10">{franchise_detail?.address ? franchise_detail?.address : ''}</p>
          <b className="d-block">Number</b>
          <p className="mb-10">{franchise_detail?.phone_number?.phone ? `+1-${this.formatPhoneNumber(franchise_detail?.phone_number?.phone)}` : ''}</p>
        </div>
      </div>
    )
  }

  // Empty revenue card
  renderEmptyRevenueCard = () => {
    return (
      <div className="card">
        <div className="card-title flex ai-center">
          <h5>Customer Metrics</h5>
        </div>
        <div className="card-body">
          <h2 style={{color: '#F99D20'}}>%</h2>
          <b>No Customer Metrics</b>
          <label>When your customers review their service, you will be able to see that here.</label>
        </div>
      </div>
    )
  }

  // render revenue card
  renderRevenueCard = () => {
    const {dashboardStat, revenueFilterIdx, customerMatrix, line_chart_options} = this.state;
    let total = 0.00, series = [], categories = [], last_6_months = [], next_6_months = [];
    if (revenueFilterIdx === 0 || revenueFilterIdx === 2) {
      for (let i = 5; i >= 0; i--) {
        last_6_months.push(moment().subtract(i, 'months').format('MMM YYYY'))
        categories.push(moment().subtract(i, 'months').format('MMM'))
        series.push(0)
      }
    } else if (revenueFilterIdx === 1) {
      for (let i = -1; i <= 4; i++) {
        next_6_months.push(moment().add(i, 'months').format('MMM YYYY'))
        categories.push(moment().add(i, 'months').format('MMM'))
        series.push(0)
      }
    }

    map(orderBy(customerMatrix?.results, 'timestamp', 'asc'), x => {
      if (revenueFilterIdx === 0 || revenueFilterIdx === 2) {
        let idx = last_6_months.indexOf(moment(x?.timestamp).format('MMM YYYY'))
        if ( idx > -1 ) {
          total += x?.revenue
          series[idx] = x?.revenue
        }

      } else if (revenueFilterIdx === 1) {
        let idx = next_6_months.indexOf(moment(x?.timestamp).format('MMM YYYY'))
        if ( moment(x?.timestamp).format('YYYY') === moment().format('YYYY') && idx > -1) {
          total += x?.revenue
          series[idx] = x?.revenue
        }
      }
    })

    return (
      <div className="card revenue">
        <div className="card-title flex ai-center">
          <h5>Revenue</h5>
          <ul className="tabs mwhite">
            <li className={revenueFilterIdx === 0 ? `active` : ''} onClick={() => this.setState({revenueFilterIdx: 0})}><span>Month</span></li>
            <li className={revenueFilterIdx === 1 ? `active` : ''} onClick={() => this.setState({revenueFilterIdx: 1})}><span>Year</span></li>
            <li className={revenueFilterIdx === 2 ? `active` : ''} onClick={() => this.setState({revenueFilterIdx: 2})}><span>All-Time</span></li>
          </ul>
        </div>
        <div className="card-body pl-0 pr-0">
          <span className="heading">${formatToCurrency(total)}
            <label className="mb-0">{revenueFilterIdx === 0 ? 'Monthly' : revenueFilterIdx === 1 ? 'Yearly' : 'All Time'} Revenue</label>
          </span>

          <div className="chart">
            {series?.length > 0 ?
              <Chart
                options={{...line_chart_options, xaxis: {
                  categories: categories,
                  labels: {
                    show: true,
                  },
                }}}
                series={[{data: series}]}
                type="line"
              /> :
              <Chart
                options={line_chart_options}
                series={[{data: new Array(6).fill(0)}] }
                type="line"
              />
            }
            <div className="form-group">
              <h3>Projections</h3>
              <div className="flex">
                <div className="flex-1 revenue_details">
                  <h2 className="success mb-0">${dashboardStat?.revenue_till_current_date ? formatToCurrency(dashboardStat?.revenue_till_current_date) : '0'}</h2>
                  <span>Work completed to <br /> <u>{moment().format('MMM Do')}</u></span>
                </div>
                <div className="flex-1 revenue_details">
                  <h2 className="success mb-0">${dashboardStat?.projections_from_current_date_to_end_of_year ? formatToCurrency(dashboardStat?.projections_from_current_date_to_end_of_year) : '0'}</h2>
                  <span>Work scheduled to end of <br /> year if services continue</span>
                </div>
              </div>
              <div className="greenbox" style={{border: "1px #407977 solid"}}>
                <h2 className="success">${dashboardStat?.current_year_projections ? formatToCurrency(dashboardStat?.current_year_projections) : '0'}</h2>
                <b>{moment().format('YYYY')} Projections</b>
              </div>
              <a href={'/#'} onClick={(e) => {e.preventDefault(); this.props.history.push('/account', { query: { current: 4 } })}}><u className="success mt-10"><b>See Unbilled Work Report</b></u></a>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // render top cards
  renderTopCards = () => {
    const {line_chart_options, top_chart_options, dashboardStat} = this.state;
    let card_list = [{
      amount: dashboardStat?.current_month_revenue?.toString(), title: `${dashboardStat?.current_month} Revenue`,
      progress: '+10', month: `Compared to ${dashboardStat?.previous_month}`
    }, {
      amount: dashboardStat?.cancelled_customers?.toString(), title: 'YTD',
      progress: '-2', month: 'Compared to last YTD', link: <u>Go To Report</u>
    }, {
      amount: dashboardStat?.all_time_revenue?.toString(), title: '',
      progress: '+1', month: 'All Time Revenue'
    }]

    return (
      <div className="top_grid flex flex-start">
        {map(card_list, (item, index) => {
          return (
            <div className="card" key={`top_cards${index}`}>
              <div className="card-body">
                <div className="small_chart flex">
                  <div className="details">
                    <h2>${this.numFormatter(item?.amount)}  <small>{item?.title}</small></h2>
                    <div className="graph_count">
                      <span className={`${item?.progress?.includes('+') ? '' : 'danger'}`}>
                        <i className={`las ${item?.progress?.includes('+') ? 'la-arrow-up' : 'la-arrow-down'}`}/> {item?.progress?.substr(1)}%
                      </span>
                      <p className="mb-0">{item?.month}</p>
                    </div>
                  </div>
                  <div className="chart">
                    <Chart
                      options={{...line_chart_options, ...top_chart_options}}
                      series={[{data: [0, 0]}]}
                      type="line"
                      width="180"
                      height="80"
                    />
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  // render full card
  renderFullCard = () => {
    const {dashboardStat, fullCardMonth} = this.state;
    let card_list = [{
      count: dashboardStat?.new_customers?.toString(), title: 'New Customers',
      progress: this.calculateGrowthPercentage(dashboardStat?.new_customers_last_year, dashboardStat?.new_customers).toString(), month: dashboardStat?.current_month
    }, {
      count: dashboardStat?.cancelled_customers?.toString(), title: 'Cancellation',
      progress: this.calculateGrowthPercentage(dashboardStat?.cancelled_customers_last_year, dashboardStat?.cancelled_customers).toString(), month: dashboardStat?.current_month, link: <a href={'/#'} onClick={(e) => {e.preventDefault(); this.props.history.push('/reports')}}><u>Go To Report</u></a>
    }, {
      count: dashboardStat?.suspended_services?.toString(), title: 'Service Suspended',
      progress: this.calculateGrowthPercentage(dashboardStat?.suspended_services_last_year, dashboardStat?.suspended_services).toString(), month: dashboardStat?.current_month
    }, {
      count: dashboardStat?.paused_services?.toString(), title: 'Service on Pause',
      progress: this.calculateGrowthPercentage(dashboardStat?.paused_services_last_year, dashboardStat?.paused_services).toString(), month: dashboardStat?.current_month
    }]
    return (
      <div className="middle_grid card flex flex-start flex-wrap">
        <div className="card-body flex flex-wrap">
          <div className="small_chart fitem flex-auto mr-2">
            <DatePicker
              disabledDate={(current) => { return current && current >= moment().endOf('month'); }}
              onChange={this.onChangeFullCardMonth}
              className="swhite summry_date_picker"
              format="MMM YYYY"
              picker="month"
              value={fullCardMonth ? fullCardMonth : moment()}  />
          </div>
          {
            map(card_list, (item, index) => {
              return (
                <div className="small_chart flex-auto mr-2" key={`full_card${index}`}>
                  <div className="details">
                    <h2>{item?.count}<small>{item?.title}</small></h2>
                    <div className="graph_count">
                      <span className={`${item?.progress?.includes('-') ? 'danger' : ''}`}>
                        <i className={`las ${item?.progress !== '0.00' ? item?.progress?.includes('-') ? 'la-arrow-down' : 'la-arrow-up' : ''}`}/> {Math.abs(item?.progress?.substr(1))}% {item?.link}
                      </span>
                      <p className="mb-0">Compared to last {item?.month}</p>
                    </div>
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }

  // render customer card
  renderCustomerCard = () => {
    const { line_chart_options, addon_options, productMonth, addonCollectionDetail, addon_series, customerFilterIdx, customerMatrixV1, customerMonth } = this.state;
    let total = 0, recurring_customers = 0, one_time_customers = 0, cancelled_customers = 0, series = [], categories = [], last_6_months = [];
    map(addonCollectionDetail?.results, x => total += x?.revenue)
    for (let i = 5; i >= 0; i--) {
      last_6_months.push(moment().subtract(i, 'months').format('MMM YYYY'))
      categories.push(moment().subtract(i, 'months').format('MMM'))
      series.push(0)
    }

    map(orderBy(customerMatrixV1?.results, 'timestamp', 'asc'), x => {
      const idx = last_6_months.indexOf(moment(x?.timestamp).format('MMM YYYY'))
      if (idx > -1) {
        recurring_customers += x?.recurring_customers
        one_time_customers += x?.one_time_customers
        cancelled_customers += x?.cancelled_customers
        if (customerFilterIdx === 0) series[idx] = x?.recurring_customers
        else if (customerFilterIdx === 1) series[idx] = x?.one_time_customers
        else if (customerFilterIdx === 2) series[idx] = x?.cancelled_customers
      }
    })

    return (
      <div className="bottom_grid flex flex-start col-69-31">
        <div className="table_with_chart inline-col-7" >
          <div className="card  mr-30">
            <div className="card-title flex ai-center" style={{padding: "10px 20px"}}>
              <h5>Customers</h5>
              <ul className="tabs mwhite d-block">
                <li className={customerFilterIdx === 0 ? `active` : ''} onClick={() => this.setState({customerFilterIdx: 0})}><span>Recurring</span></li>
                <li className={customerFilterIdx === 1 ? `active` : ''} onClick={() => this.setState({customerFilterIdx: 1})}><span>One-Time</span></li>
                <li className={customerFilterIdx === 2 ? `active` : ''} onClick={() => this.setState({customerFilterIdx: 2})}><span>Cancellations</span></li>
                <li><DatePicker
                  disabledDate={(current) => { return current && current >= moment().endOf('month'); }}
                  onChange={this.onChangeCustomerMonth}
                  className="swhite summry_date_picker"
                  format="MMM YYYY"
                  picker="month"
                  value={customerMonth ? customerMonth : moment()}  />
                </li>
              </ul>
            </div>
            <div className="card-body p-0">
              <div style={{ 'padding': '20px' }}>
                <h2 className="mb-0">{customerFilterIdx === 0 ? recurring_customers : customerFilterIdx === 1 ? one_time_customers : cancelled_customers}</h2>
                <label className="mb-0">{customerFilterIdx === 0 ? 'Recurring Signups' : customerFilterIdx === 1 ? 'One-time' : 'Cancellation'}</label>
              </div>

              {series?.length > 0 ?
                <Chart
                  options={{...line_chart_options, xaxis: {
                    categories: categories,
                    labels: {
                      show: true,
                    },
                  }}}
                  series={[{data: series}]}
                  type="line"
                  height={'150'}
                /> :
                <Chart
                  options={{...line_chart_options}}
                  series={[{data: new Array(6).fill(0)}] }
                  type="line"
                  height={'150'}
                />}

            </div>

            <ul className="chart_bottom_list">
              <li>
                <h5>{recurring_customers ? recurring_customers : '0'}</h5>
                <label>Recurring</label>
              </li>
              <li>
                <h5>{one_time_customers ? one_time_customers : '0'}</h5>
                <label>One-Time</label>
              </li>
              <li>
                <h5>{cancelled_customers ? cancelled_customers : '0'}</h5>
                <label>Cancellations</label>
              </li>
            </ul>
          </div>


        </div>
        <div className="pie_chart_card inline-col-3">
          <div className="card">
            <div className="card-title">
              <h5>Products</h5>
              <DatePicker
                disabledDate={(current) => { return current && current >= moment().endOf('month'); }}
                onChange={this.onChangeProductMonth}
                className="swhite summry_date_picker"
                format="MMM YYYY"
                picker="month"
                value={productMonth ? productMonth : moment()}  />
            </div>
            <div className="card-body">
              {
                addon_series?.every(item => item === 0) ?
                  <Chart
                    ref={(ref) => this.emptyProductChart = ref}
                    type="donut"
                    options={{...addon_options, colors: ['#ecebeb'], tooltip: {enabled: false}, states: {hover: 'none'} }}
                    series={[0.1]} /> :
                  <Chart
                    type="donut"
                    options={{...addon_options, colors: pie_colors}}
                    series={addon_series} />
              }
              <ul className="chart_details_list">
                {map(addonCollectionDetail?.results, (item, index) => {
                  if (item?.revenue) {
                    return (
                      <li key={item?.uuid} className={pie_colors_class[index]}>
                        <span>{item?.addon?.name}</span>
                        <span>${item?.revenue ? item?.revenue : '0'}</span>
                        <span>{item?.revenue ? parseFloat((item?.revenue * 100) / total).toFixed(2) : '0'}%</span>
                      </li>
                    )
                  }
                } )}
              </ul>
            </div>
          </div>
        </div>

      </div>
    )
  }

  render() {
    const {collectionDetail, loader, customerMatrix} = this.state;
    return (
      <div className="overview_wrapper">
        {loader && <Loader />}
        <div className="aside-area pt-0">
          <aside className="">
            {this.renderFranchiseInfo()}
            {/* Customer Matrix */}
            {customerMatrix?.results?.length > 0 ? this.renderRevenueCard() : this.renderEmptyRevenueCard()}
          </aside>
          <div className="main p-0">
            {/* Top 3 Card Start */}
            {/*{this.renderTopCards()}*/}
            {/* Top 3 Card End */}
            {/* Full Card Start*/}
            {this.renderFullCard()}
            {/* Full Card End*/}
            {this.renderCustomerCard()}
            <div className="bottom_grid flex flex-start mt-30">
              <Table
                rowKey={record => record.uuid}
                dataSource={collectionDetail?.results}
                pagination={false}
                columns={DataTable.FranchiseCollection(this)}
                className="table"
              />
            </div>

          </div>

          <Drawer
            visible={this.state.is_edit_franchise}
            width={'420'}
            closable={false}
            className="drawer-wrapper create_ticket_drawer"
          >
            <EditFranchise

              closeEditDrawer={this.closeEditDrawer}
              //Reducer
              UserList={this.props.UserList}
              EditFieldOffice={this.props.EditFieldOffice}
              UpdateFranchise={this.props.UpdateFranchise}
              Settings={this.props.Settings}
              GoogleApi={this.props.GoogleApi}
              // API Call
              getFieldOffice={this.props.getFieldOffice}
              getFranchiseList={this.props.getFranchiseList}
              getUserList={this.props.getUserList}
              updateFieldOffice={this.props.updateFieldOffice}
              getUserDetail={this.props.getUserDetail}
              getGeocodeAddress={this.props.getGeocodeAddress}
              resetGeocodeAddress={this.props.resetGeocodeAddress}
            />
          </Drawer>

        </div>
      </div >
    );
  }
}

const mapDispatchToProps = {
  getUserList,
  getFieldOffice
};

const mapStateToProps = (state) => {
  return {
    UserList: state.UserList
  }
}

// export default Overview;

export default connect(mapStateToProps, mapDispatchToProps)(Overview);